import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import ExperienceCard from "../components/ExperienceCard";
import SectionHeader from "../components/SectionHeader";
import { experiences } from "../data/site";
import { usePhotoOverrides } from "../lib/photos";

const ZAZITKY_ORDER = [
  "pobyt-u-vinare", "rodinny-pobyt-na-jizni-morave", "rizena-degustace", "piknik-ve-vinohrade",
  "degustace-ve-vinohrade", "sezonni-zazitky", "soukrome-oslavy", "firemni-akce",
];
const RECOMMENDED = new Set(["pobyt-u-vinare", "rodinny-pobyt-na-jizni-morave", "rizena-degustace"]);

export default function Zazitky() {
  const photos = usePhotoOverrides();
  const ordered = ZAZITKY_ORDER.map((s) => experiences.find((e) => e.slug === s)).filter(Boolean);
  return (
    <main id="main">
      <Seo path="/zazitky" title="Vinařské zážitky, degustace a pobyty | Vinařství Brychta"
        description="Vyberte si z osmi vinařských zážitků – řízené degustace, degustace ve vinohradě, piknik, rodinný pobyt, firemní programy a sezonní zážitky." />
      <Breadcrumbs items={[{ label: "Zážitky" }]} />
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 md:py-20">
        <SectionHeader as="h1" eyebrow="Naše zážitky" title="Osm způsobů, jak strávit čas u vína"
          kicker="Vyberte si podle nálady, počtu osob a délky pobytu. Rádi vám nabídku upravíme na míru." />

        <div className="mt-10 bg-cream border border-charcoal/10 p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-6" data-testid="zazitky-accommodation-callout">
          <div className="flex-1">
            <div className="text-[11px] tracking-[.25em] uppercase text-burgundy">Ubytování</div>
            <h2 className="font-serif text-2xl md:text-3xl mt-2">Zůstaňte rovnou přes noc</h2>
            <p className="mt-3 text-sm md:text-base text-charcoal/80 leading-relaxed max-w-2xl">
              Nabízíme tři apartmány v Charvátské Nové Vsi, kousek od Lednice a Valtic. Konkrétní apartmán potvrzujeme osobně podle počtu hostů a aktuální dostupnosti.
            </p>
            <ul className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-sm text-charcoal/75">
              <li>500 Kč / osoba / noc</li>
              <li>Minimálně 2 noci</li>
              <li>Bezpečné uložení až cca 14 kol</li>
            </ul>
          </div>
          <Link to="/ubytovani" className="inline-flex items-center gap-2 bg-burgundy hover:bg-burgundy-hover text-ivory px-6 py-3 tracking-wide shrink-0">Prohlédnout ubytování</Link>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ordered.map((e, i) => {
            const override = photos.first("experience", e.slug);
            const recommended = RECOMMENDED.has(e.slug);
            return (
              <div key={e.slug}>
                <ExperienceCard exp={{ ...e, featured: recommended }} index={i}
                  imageOverride={override?.src} altOverride={override?.alt} waiting={!photos.loaded} />
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
}
